export default "__VITE_ASSET__BvHT4M5T__"